













































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Validator } from 'vee-validate';
import { Base } from '@/components/common/base';
import { TenantInfo } from '@/models/inventory/vehiclerevivestep';
import { Richtext } from 'dhx-richtext';
import 'dhx-richtext/codebase/richtext.css';
import { IDialogOption } from '@/models/dialog';
import { formSubmit } from '@servicestack/client';
import { LoginModel } from '@/models/admin/users';
import * as marked from 'marked';
import * as dhx from 'dhx-richtext';
import {vehicleReconStepService} from '@/shared';

@Component({
  props: ['dialog', 'recordKey'],
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Richtext,
  },
  computed: {
    previewText() {
      return marked(this.md_text);
    },
  },
})
export default class NoteComponent extends Base {
  get trigger(): boolean {
    return this.$props.dialog;
  }
  set trigger(val) {
    this.$emit('closedialog', val);
  }

  public $validator: Validator;
  public loading: boolean = false;
  public pagination = new PaginationModel('createdAt', true, 5);
  public actions: any[] = [];
  public items: any[] = [];
  public dialog: boolean;
  public noteTextToDisplay: string = '';
  public recordKey: string;
  public noteText: string = '';
  public noteId: number = 0;
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public html: string = '';
  public disableSaveNote: boolean = false;

  public css: string = '';
  public mode: { type: string; default: 'classic' };
  public value: string = '';

  public dataType: { type: string; default: 'markdown' };
  public richtext: Richtext;
  public markdown: string = '';

  public tenantInfo: TenantInfo = {
    tenantId: 0,
    enterpriseId: 0,
    storeId: 0,
  };
  public NoteDialog: IDialogOption = {
    width: 800,
    title: this.$parent.$t('vehicleReviveNotes.noteDialog.title') as string,
    model: false,
  };
  public headers: VHeaders[] = [
    {
      text: this.$parent.$t(
        'vehicleReviveNotes.noteGridHeaders.note'
      ) as string,
      align: 'left',
      sortable: false,
      value: 'noteText',
      fieldType: 'html',
      filters: [
        (item) => {
          const htmlData = marked(item);
          return htmlData.length > 100
            ? htmlData.substring(0, 100) + '..'
            : htmlData;
        },
      ],
      class: 'w-100 text-truncate',
    },
    {
      text: this.$parent.$t(
        'vehicleReviveNotes.noteGridHeaders.addedAt'
      ) as string,
      value: 'createdAt',
      sortable: true,
      align: 'left',
      fieldType: 'date',
    },
    {
      text: this.$parent.$t(
        'vehicleReviveNotes.noteGridHeaders.addedBy'
      ) as string,
      value: 'createdByEmail',
      align: 'left',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: this.$parent.$t(
        'vehicleReviveNotes.noteGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('vehicleReviveNotes.deleteDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'vehicleReviveNotes.deleteDialog.btnText'
      ) as string,
    },
    loading: false,
    onAction: (): void => {
      this.deleteNote();
    },
  };

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: this.$t(
          'vehicleReviveNotes.noteGridHeaders.gridAction.view'
        ) as string,
        color: 'primary',
        action: (val) => {
          this.showNote(val.noteText);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'vehicleReviveNotes.noteGridHeaders.gridAction.delete'
        ) as string,
        color: 'error',
        visible: () => {
          return this.isAuthorizedToAccess(['ReviveAdmin']);
        },
        action: (val) => {
          this.confirmDelete(val.id);
        },
      },
    ];
  }
  public showNote(item: any): void {
    this.noteTextToDisplay = marked(item);
    this.NoteDialog.model = true;
  }

  public confirmDelete(id: number): void {
    this.deleteDialog.model = true;
    this.noteId = id;
  }
  public async deleteNote(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      this.tenantInfo = {
        tenantId: this.reviveSession.tenantId,
        enterpriseId: this.reviveSession.enterpriseId,
        storeId: this.reviveSession.storeId,
      };
      await vehicleReconStepService.deleteNoteAsync(
        this.recordKey,
        this.noteId,
        this.tenantInfo
      );
      this.getNotes(this.recordKey);
      this.showAlert(true, this.$t('vehicleReviveNotes.alertNoteDeleted'));
    } catch (e) {
      console.log(e);
    } finally {
      this.deleteDialog.loading = true;
      this.deleteDialog.model = false;
    }
  }
  public created() {
    dhx.i18n.setLocale('richtext', this.$t('richText'));
  }

  public mounted() {
    this.setActions();
    this.richtext = new Richtext(this.$refs.container, {
      mode: this.mode,
      css: this.css,
    });

    this.$watch('recordKey', (newVal, oldVal) => {
      this.getNotes(this.recordKey);
    });
  }
  public async getNotes(recordKey): Promise<void> {
    try {
      this.tenantInfo = {
        tenantId: this.reviveSession.tenantId,
        enterpriseId: this.reviveSession.enterpriseId,
        storeId: this.reviveSession.storeId,
      };
      this.loading = true;
      if (this.tenantInfo && recordKey) {
        const response = await vehicleReconStepService.getNotes(
          recordKey,
          this.tenantInfo
        );
        this.items = [];
        this.items = response.results;
        if (this.items) {
          this.pagination.totalItems = this.items.length || 0;
        }
      }
    } finally {
      this.loading = false;
    }
  }

  public async saveNote(): Promise<void> {
    try {
      this.tenantInfo = {
        tenantId: this.reviveSession.tenantId,
        enterpriseId: this.reviveSession.enterpriseId,
        storeId: this.reviveSession.storeId,
      };

      this.noteText = this.richtext.getValue('markdown');
      if (!this.noteText) {
        this.showAlert(
          false,
          this.$t('vehicleReviveNotes.alertNoteTextNotEmpty')
        );
        return;
      }
      this.disableSaveNote = true;
      await vehicleReconStepService.addNote(
        this.recordKey,
        this.noteText,
        this.tenantInfo
      );

      this.noteText = '';
      this.markdown = '';
      this.richtext.setValue(this.markdown, this.dataType);

      this.getNotes(this.recordKey);
      this.showAlert(true, this.$t('vehicleReviveNotes.alertNoteAdded'));
      this.$validator.reset();
    } finally {
      this.disableSaveNote = false;
    }
  }

  public closeDialog() {
    this.trigger = false;
    this.$validator.reset();
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }
}
